/**
 * How many stock market 'ticks' before a 'cycle' is triggered.
 * A 'tick' is whenever stock prices update
 */
export const TicksPerCycle = 75;
